export type StickerTone = "brand" | "tint" | "white";

export interface Greeting {
  word: string;
  language: string;
  lang: string;
}

export interface Sticker {
  word: string;
  speech: string;
  language: string;
  lang: string;
  code: string;
  x: number;
  y: number;
  rotate: number;
  tone: StickerTone;
  depth: number;
  mobile: boolean;
}

export const greetings: Greeting[] = [
  { word: "Hola", language: "Spanish", lang: "es-ES" },
  { word: "Bonjour", language: "French", lang: "fr-FR" },
  { word: "こんにちは", language: "Japanese", lang: "ja-JP" },
  { word: "Ciao", language: "Italian", lang: "it-IT" },
  { word: "Olá", language: "Portuguese", lang: "pt-BR" },
  { word: "안녕하세요", language: "Korean", lang: "ko-KR" },
  { word: "Hallo", language: "German", lang: "de-DE" },
  { word: "Merhaba", language: "Turkish", lang: "tr-TR" },
  { word: "Привет", language: "Russian", lang: "ru-RU" },
  { word: "Hej", language: "Swedish", lang: "sv-SE" },
];

export const stickers: Sticker[] = [
  { word: "Hola", speech: "Hola", language: "Spanish", lang: "es-ES", code: "ES", x: 30, y: 6, rotate: -8, tone: "brand", depth: 1, mobile: false },
  { word: "Bonjour", speech: "Bonjour", language: "French", lang: "fr-FR", code: "FR", x: 74, y: 8, rotate: 6, tone: "white", depth: 0.6, mobile: true },
  { word: "Hallo", speech: "Hallo", language: "German", lang: "de-DE", code: "DE", x: 3, y: 34, rotate: 7, tone: "tint", depth: 0.7, mobile: false },
  { word: "こんにちは", speech: "こんにちは", language: "Japanese", lang: "ja-JP", code: "JA", x: 4, y: 62, rotate: 5, tone: "tint", depth: 0.8, mobile: false },
  { word: "Привет", speech: "Привет", language: "Russian", lang: "ru-RU", code: "RU", x: 6, y: 86, rotate: -4, tone: "white", depth: 1.2, mobile: true },
  { word: "مرحبا", speech: "مرحبا", language: "Arabic", lang: "ar-SA", code: "AR", x: 87, y: 30, rotate: -5, tone: "tint", depth: 1.1, mobile: false },
  { word: "Ciao", speech: "Ciao", language: "Italian", lang: "it-IT", code: "IT", x: 86, y: 56, rotate: -10, tone: "white", depth: 0.9, mobile: false },
  { word: "Olá", speech: "Olá", language: "Portuguese", lang: "pt-BR", code: "PT", x: 78, y: 84, rotate: 9, tone: "brand", depth: 0.9, mobile: true },
  { word: "안녕", speech: "안녕", language: "Korean", lang: "ko-KR", code: "KO", x: 60, y: 92, rotate: -6, tone: "tint", depth: 0.5, mobile: false },
  { word: "Namaste", speech: "नमस्ते", language: "Hindi", lang: "hi-IN", code: "HI", x: 26, y: 92, rotate: 4, tone: "white", depth: 0.7, mobile: false },
];
